<template>
  <loading
    :active="loading"
    :can-cancel="canCancel"
    :is-full-page="isFullPage"
    :loader="loader"
    :opacity="opacity"
    :on-cancel="onCancel"
    :blur="blur"
  />
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
  name: "UniversalLoader",

  components: {
    Loading,
  },

  props: {
    loading: Boolean,
    loader: {
      type: String,
      default: "dots",
    },
    opacity: {
      type: Number,
      default: 0.3,
    },
    isFullPage: {
      type: Boolean,
      default: true,
    },
    blur: {
      type: String,
      default: "2px",
    },
    canCancel: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onCancel() {
      this.$emit("loaderCancelled");
    },
  },
};
</script>
